import { render, staticRenderFns } from "./TrafficSources.vue?vue&type=template&id=4966eb4c&scoped=true"
import script from "./TrafficSources.vue?vue&type=script&lang=js"
export * from "./TrafficSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966eb4c",
  null
  
)

export default component.exports